import api from "../services/api";
import { $Q, $Qll } from "../utils/query-selector"
import { stringToHTML } from "../utils/to-html";
import { btnAddToCart } from "./cart";
import { onClickProductCard } from "./modal-cart";

/**
 * @param {String} element identifier to search node
 */
export const collectionMoreInfo = (element) => {
  const node = $Q(element);
  if(!node) return;

  let currentPage = 2;
  let totalPages = 1;

  node.addEventListener('click', async(e) => {
    e.preventDefault();
    if((totalPages !== 1) && (currentPage === totalPages + 1)) {
      return;
    }

    hideCollectionPoster();
    updateCurrentPage();
    totalPages = await fetchAllCollectionProducts(currentPage);
    evaluateHideButton(totalPages, currentPage);
    if (totalPages + 1 > currentPage) currentPage += 1;
  })
}

/**
 * It updates the current page for collection grid
 */
const updateCurrentPage = () => {
  const collectionGrid = $Q('.main-collection__grid');

  if(!collectionGrid) return;

  const currentPage = parseInt(collectionGrid.dataset.current);
  collectionGrid.dataset.current = currentPage + 1;
}

/**
 * @param {Number} page : is the current page for collection product cards
 * @returns {Number} totalPages : is the number of total pages
 */
async function fetchAllCollectionProducts(page) {
  const collection_detail = $Q('.main-collection__grid');
  const collection_url = collection_detail.dataset.url;
  const totalPages = collection_detail.dataset.pages;
  const sectionId = collection_detail.dataset.id;

  const params = {
    sections: sectionId,
    page
  }

  const response = await api.shopifySectionByUrlAndParams(collection_url, params);
  const sectionHTML = stringToHTML(response[sectionId]);
  const newCollectionList = getCollectionListFetched(sectionHTML);
  updateCollectionList(collection_detail, newCollectionList);

  if(typeof totalPages === 'string') {
    return parseInt(totalPages);
  }
}

/**
 * @param {Document} sectionHTML : is the HTML section got from section rendering api
 * @returns {Array} list : is list of HTML elements
 */
function getCollectionListFetched(sectionHTML) {
  const list = $Qll('.js-product-card', sectionHTML);
  return list;
}

/**
 * It updates the events for new products cards on DOM
 * @param {Document} collection is the HTML section got from main collection
 * @param {Array} newCollectionList is the list of HTML elements (product cards)
 */
function updateCollectionList (collection, newCollectionList) {
  const list = $Qll('.js-product-card', collection);
  if(!newCollectionList) return;

  console.log('newCollectionList', newCollectionList);
  console.log('list', list);

  newCollectionList.forEach(element => {
    collection.appendChild(element);
  })
  btnAddToCart('.add-product-cart');
  onClickProductCard();
}

/**
 * This functions hide collection poster
 */
function hideCollectionPoster() {
  const poster = $Q('.main-collection__poster');

  if(!poster) return;

  poster.classList.add('hidden');
}

/**
 *
 * @param {Number} totalPages is the number of total pages
 * @param {Number} currentPage is the current page
 */
function evaluateHideButton(totalPages, currentPage) {
  if(totalPages === currentPage) {
    const button = $Q('#collection__button');
    if(!button) return;

    button.classList.add('hidden');
  }
}
